import { JSONSchema6 } from "json-schema";

const captureChargeSchema: JSONSchema6 =
{
    title: "Capture Charge",
    description: "Capture payment on a Charge in the Authorized state. A successful Capture will move the Charge from Authorized to Captured state. The Captured state may be preceded by a temporary CaptureInitiated state if payment was captured more than 7 days after authorization. An unsuccessful Charge will move to a Declined state if payment was declined.",
    properties: {
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-idempotency-key": {
                    type: "string"
                }
            },
            required: ["x-amz-pay-idempotency-key"]
        },
        "pathParam": {
            title: "chargeId",
            type: "string"
        },
        "payload": {
            type: "object",
            properties: {
                "captureAmount": {
                    type: "object",
                    properties: {
                        "amount": {
                            type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    },
                    required: ["amount", "currencyCode"]
                },
                "softDescriptor": {
                    type: "string"
                }
            },
            required: ["captureAmount"]
        }
    },
    required: ["header", "pathParam", "payload"]
}

export default captureChargeSchema
